export default {
    BRICK: 'brick',
    BRICK_VENEER: 'brick-veneer',
    CONCRETE_BLOCKS: 'concrete-blocks',
    LOG: 'log',
    MASONRY_VENEER: 'masonry-veneer',
    STONE: 'stone',
    STONE_VENEER: 'stone-veneer',
    STUCCO: 'stucco',
    VINYL: 'vinyl',
    WOOD_EXTERIOR: 'wood-exterior',
    OTHER: 'other', //we force other to the bottom
};
